export const SPECIES_QUERY = `
query Species {
  species {
    id
    sanaId
    name
    group
    productsForshaw
    productsFrs
  }
}
`

export const SPECIES_SET_GROUP_MUTATION = `
mutation SpeciesSetGroup($id: Int!, $group: String!) {
  speciesSetGroup(id: $id, group: $group) {
    result {
      id
      group
    }
    errors
  }
}
`
